'use strict';

const Mn = require('backbone.marionette');
const _ = require('underscore');
const Backbone = require('backbone');
const i18n = require('i18next');
const MemberModel = require('common/domain/entity/project-member');
const ProjectMemberIconView = require('common/ui/view/project/member-icon');
const ProjectMemberNameView = require('common/ui/view/project/member-name');
const ProjectRoleRepository = require('common/domain/repository/project-role');
const ItemTemplate = require('balus/ui/template/body/project/sidebar/member-item.hbs');
const Template = require('balus/ui/template/body/project/sidebar/member.hbs');
const SubHeaderTemplate = require('balus/ui/template/body/project/sidebar/member-sub-header.hbs');

const MemberItemView = Mn.View.extend({
    model: MemberModel,
    tagName: 'li',
    className: 'list-item',
    template: ItemTemplate,
    regions: {
        icon: '.list-item-icon',
        title: '.list-item-header-title',
    },
    templateContext: function() {
        const projectRole = this.getOption('projectRoles').get(this.model.getRole());
        return {
            role: projectRole ? projectRole.getName() : ''
        };
    },
    onRender: function() {
        this.showChildView('icon', new ProjectMemberIconView({model: this.model}));
        this.showChildView('title', new ProjectMemberNameView({model: this.model}));
    }
});

const MemberListView = Mn.CollectionView.extend({
    tagName: 'table',
    className: 'list list-bordered member-list',
    childView: MemberItemView,
    childViewOptions: function() {
        return {
            projectRoles: this.getOption('projectRoles')
        }
    }
});

const ListSubHeaderView = Mn.View.extend({
    template: SubHeaderTemplate,

    initialize: function(params) {
        this._role = params.role;
    },

    templateContext: function() {
        const notSuspendedMembers = _.filter(this.collection.models, (member) => {return !member.get('suspended') });
        return {
            number: notSuspendedMembers.length,
            role: this._role
        };
    }
});

module.exports = Mn.View.extend({
    template: Template,
    regions: {
        ownerMemberHeader: '.owner-member-sub-header-wrapper',
        ownerMemberList: '.owner-member-list-wrapper',
        playerMemberHeader: '.player-member-sub-header-wrapper',
        playerMemberList: '.player-member-list-wrapper',
        collaboratorMemberHeader: '.collaborator-member-sub-header-wrapper',
        collaboratorMemberList: '.collaborator-member-list-wrapper'
    },

    initialize: function() {
        const groupedMembers = _.groupBy(this.collection.models, (member) =>{ return member.get('role') });
        this._ownerMembers = new Backbone.Collection(groupedMembers['owner']);
        this._playerMembers = new Backbone.Collection(groupedMembers['player']);
        this._collaboratorMembers = new Backbone.Collection(groupedMembers['collaborator']);
    },

    templateContext: function() {
        const notSuspendedMembers = _.filter(this.collection.models, (member) => {return !member.get('suspended') });
        return {
            projectMemberNumber: notSuspendedMembers.length
        };
    },

    onRender: function() {
        ProjectRoleRepository.find(this.getOption('group')).fetchRoles()
            .then(projectRoles => {
                this.showChildView('ownerMemberHeader', new ListSubHeaderView({
                    collection: this._ownerMembers,
                    role: i18n.t('project-role.owner')
                }));
                this.showChildView('ownerMemberList', new MemberListView({
                    collection: this._ownerMembers,
                    projectRoles: projectRoles
                }));
                this.showChildView('playerMemberHeader', new ListSubHeaderView({
                    collection: this._playerMembers,
                    role: i18n.t('project-role.player')
                }));
                this.showChildView('playerMemberList', new MemberListView({
                    collection: this._playerMembers,
                    projectRoles: projectRoles
                }));
                this.showChildView('collaboratorMemberHeader', new ListSubHeaderView({
                    collection: this._collaboratorMembers,
                    role: i18n.t('project-role.collaborator')
                }));
                this.showChildView('collaboratorMemberList', new MemberListView({
                    collection: this._collaboratorMembers,
                    projectRoles: projectRoles
                }));
            });
    },
});



// WEBPACK FOOTER //
// ./balus/ui/view/body/project/sidebar/member.js